var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkMobileReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 .995A1 1 0 0 1 1.007 0h12.986C14.549 0 15 .456 15 .995v8.01c0 .55-.447.995-.996.995H7.5l-3 4H4v-4H1.01C.451 10 0 9.544 0 9.005z"
})));
export default SvgVkMobileReply;